const state = {
  audioData: {},
  audioActive: false,
  playerDimensions: {},
  playerPosition: {},
};

const mutations = {
  CHANGE_AUDIO_CONTENT(state, audioObj) {
    state.audioData = audioObj;
  },
  CHANGE_AUDIO_ACTIVE(state, audioActive) {
    state.audioActive = audioActive;
  },
  PLAYER_DIMENSIONS(state, playerObj) {
    state.playerDimensions = playerObj;
  },
  PLAYER_POSITION(state, playerObj) {
    state.playerPosition = playerObj;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  audioData: (state) => {
    return state.audioData;
  },
  audioActive: (state) => {
    return state.audioActive;
  },
  playerDimensions: (state) => {
    return state.playerDimensions;
  },
  playerPosition: (state) => {
    return state.playerPosition;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
